<template>
  <div class="view box grow flex column">
    <page-headers :header="'Dashboard'" documentation="page-dashboard" class="box">
      <div slot="actions" class="float-right">
        <date-range-dropdown
          :store-pref-constant="daterangeUserPrefConstant"
          :date-range-val="dashboardProgressionDateRangeUserSetting"
        ></date-range-dropdown>
      </div>
    </page-headers>
    <el-row :type="'flex'">
      <el-col :span="8" :offset="0">
        <el-card
          shadow="never"
          class="cursor-pointer"
          :class="{ 'active-card': activePostureSelection === 'trails' }"
          v-if="trailSummaryStatus === 'saved' || cardViewStatusOnce === true"
          v-loading="trailSummaryStatus === 'loading'"
        >
          <div class="flex column" @click="goToNestedView('trails')">
            <div class="box flex grid-2 card-header">
              <div class="col-1 box grow flex">
                <h3 class="box grow">
                  THREAT PROGRESSIONS
                  <el-link @click="loadDocumentation('dashboard-threat-progressions')" :underline="false"
                    ><i class="material-icons">help_outline</i></el-link
                  >
                </h3>
                <h2 class="box float-right">{{ activeTrailSummary.numTrails }}</h2>
              </div>
            </div>
            <div class="box flex card-content small-font">
              <div class="box grow">
                <span class="subtitle1">BY ASSIGNEE:&nbsp</span>
                <div class="display-inline-block avatar-wrapper" v-if="usersListStatus === 'saved'">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="`${user.firstname} ${user.lastname}`"
                    placement="bottom"
                    :enterable="false"
                    v-for="(user, idx) in visibleUsers"
                    :key="idx"
                  >
                    <user-button
                      :class="[avatarColorOptions[idx], { active: user.checked }]"
                      @button-click="
                        user.checked = !user.checked
                        filterByAssignee(user)
                      "
                      :user="user"
                    />
                  </el-tooltip>

                  <el-dropdown v-if="dropdownUsers.length > 0" :hide-on-click="false">
                    <el-button type="text" circle class="uppercase avatar-circle aluminum-400"
                      >+{{ dropdownUsers.length }}</el-button
                    >
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="(ddUser, idx) in dropdownUsers" :key="idx">
                        <el-checkbox
                          v-model="ddUser.checked"
                          :checked="false"
                          @change="filterByAssignee(ddUser)"
                        ></el-checkbox>
                        <span v-if="ddUser.email === 'unassigned'">
                          <user-button />
                          {{ `${ddUser.firstname}` }}
                        </span>
                        <span v-if="ddUser.email !== 'unassigned'">
                          <user-button :class="avatarColorOptions[idx]" :user="ddUser" />
                          &nbsp{{ `${ddUser.firstname} ${ddUser.lastname}` }}
                        </span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
              <div class="box flex column">
                <div class="box grow" v-for="(prop, idx) in activeTrailSummary.summaryInfo" :key="idx">
                  <el-tooltip class="item" effect="dark" :content="prop.label" placement="bottom" :enterable="false">
                    <span :class="`${prop.key}-risk-color`" class="color-block"></span>
                  </el-tooltip>
                  <span class="box grow">{{ prop.count }}</span>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8" :offset="0">
        <el-card
          shadow="never"
          class="cursor-pointer"
          :class="{ 'active-card': activePostureSelection === 'privileged' }"
          v-if="trailSummaryStatus === 'saved' || cardViewStatusOnce === true"
          v-loading="trailSummaryStatus === 'loading'"
        >
          <div class="flex column" @click="goToNestedView('privileged')">
            <div class="box flex card-header">
              <div class="box grow flex">
                <div class="box grow">
                  <h3>
                    PRIVILEGED ACTIVITIES
                    <el-link @click="loadDocumentation('dashboard-privileged-activities')" :underline="false"
                      ><i class="material-icons">help_outline</i></el-link
                    >
                  </h3>
                </div>
                <div class="box">
                  <h2 class="float-right">{{ privilegedTrailSummary.numTrails }}</h2>
                </div>
              </div>
            </div>
            <div class="box grow col-3 flex privilege-content">
              <div class="flex column"><span class="box icon icon-privilege-activities"></span></div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8" :offset="0">
        <el-card
          shadow="never"
          class="system-summary cursor-pointer"
          :class="{ 'active-card': activePostureSelection === 'agents' }"
          v-if="trailSummaryStatus === 'saved' || cardViewStatusOnce === true"
          v-loading="trailSummaryStatus === 'loading'"
        >
          <div class="flex grid-8" @click="goToNestedView('agents')">
            <div class="box col-5 grow flex column card-header summary-chart">
              <div class="box">
                <h3>
                  SYSTEM STATUS
                  <el-link @click="loadDocumentation('dashboard-system-status')" :underline="false"
                    ><i class="material-icons">help_outline</i></el-link
                  >
                </h3>
                <div class="system-summary_events">
                  <span class="subtitle1">Events Consumed:</span>
                  <ICountUp
                    :delay="eventsConsumedCounter.delay"
                    :endVal="eventsConsumedCounter.endVal"
                    :options="eventsConsumedCounter.options"
                  />
                  <span class="subtitle1 float-right">{{ activeTrailSummary.totalActiveRiskScore }}</span>
                </div>
              </div>
              <div class="box">
                <line-chart-js
                  :chart-id="'1'"
                  :chart-data="{
                    labels: [1551479647086, 1551479693698, 1551479694865, 1551479696341, 1551479698341],
                    datasets: [{ data: [25, 89, 90, 230, 245] }]
                  }"
                  :chart-options="summaryInfoLineChartOptions"
                  style="position: relative; width: 50%; max-height: 85px;"
                ></line-chart-js>
              </div>
            </div>
            <div class="box grow col-3 flex justify-flex-end small-font">
              <div class="flex column">
                <h2 class="float-right">{{ trailSummary.numAgents - trailSummary.numAgentsDecommissioned }}</h2>
                <div class="box" v-for="(prop, idx) in trailSummary.systemSummary.agents.summaryInfo" :key="idx">
                  <el-tooltip class="item" effect="dark" :content="prop.label" placement="bottom" :enterable="false">
                    <span :class="`${prop.key}-color`" class="color-block"></span>
                  </el-tooltip>
                  <span class="box center-text">{{ prop.count }}</span>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :type="'flex'" class="box grow"> <router-view class="full-width" /> </el-row>
  </div>
</template>

<script>
import ICountUp from 'vue-countup-v2'
import { mapGetters } from 'vuex'
import { registerInverval, destroyInverval } from '@/utilities/global.interval'
import { DASHBOARD_POLLING_INTERVAL } from '@/constants/polling-interval.constants'
import {
  TRAIL_SUMMARY_REQ,
  SYSTEM_TRAIL_SUMMARY_REQ,
  UNIQ_COMBO_LATERAL_MOVEMENT,
  UNIQ_COMBO_PRIV_LATERAL_MOVEMENT
} from '@/store/modules/trails/trailsinfo.type'
import { USER_LIST_REQUEST, USER_LIST_SUCCESS } from '@/store/modules/user/user.type'
import { DASHBOARD_PROGRESSION_DATE_RANGE_PREFERENCE } from '@/store/modules/user_pref/user-pref.type'

import PageHeaders from '@/components/layout/PageHeaders.vue'
import LineChartJs from '@/components/chart/LineChartJs.vue'
import UserButton from '@/components/button/UserButton.vue'
import DateRangeDropdown from '@/components/dropdown/DateRangeDropdown.vue'
import loadDocumentationMixin from '@/mixins/loadDocumentationMixin'

export default {
  name: 'ParentSecurityPostureDashboard',
  mixins: [loadDocumentationMixin],
  data () {
    return {
      daterangeUserPrefConstant: DASHBOARD_PROGRESSION_DATE_RANGE_PREFERENCE,
      cardViewStatusOnce: false,
      summaryIntervalId: {},
      eventsConsumedCounter: {
        delay: 1000,
        endVal: 0,
        options: {
          useEasing: true,
          useGrouping: true,
          separator: ','
        }
      },
      visibleUsers: [],
      dropdownUsers: [
        {
          email: 'unassigned',
          firstname: 'Unassigned'
        }
      ],
      avatarColorOptions: [
        'shamrock-200',
        'amaranth-300',
        'candlelight-700',
        'denim-300',
        'tuna-600',
        'shamrock-500',
        'amaranth-700',
        'candlelight-900',
        'denim-700',
        'tuna-800'
      ]
    }
  },
  created () {
    if (this.insightsEnabled) {
      this.$router.push({ name: 'dashboard-analytics' })
      return false
    }
    if (this.usersListStatus !== 'saved') {
      this.$store.dispatch(USER_LIST_REQUEST).then(users => {
        this.$store.dispatch(USER_LIST_SUCCESS)
        if (users.models.length > 6) {
          this.visibleUsers = users.models.slice(0, 6)
          this.dropdownUsers = this.dropdownUsers.concat(users.models.slice(6, users.models.length))
        } else {
          this.visibleUsers = users.models.slice(0, 6)
        }
      })
    } else {
      if (this.usersList.models.length > 6) {
        this.visibleUsers = this.usersList.models.slice(0, 6)
        this.dropdownUsers = this.dropdownUsers.concat(this.usersList.models.slice(6, this.usersList.models.length))
      } else {
        this.visibleUsers = this.usersList.models.slice(0, 6)
      }
    }

    // initial load, call backend else use cached data
    if (this.trailSummaryStatus === 'saved') {
      this.cardViewStatusOnce = true
      this.eventsConsumedCounter.endVal = this.trailSummary.numEventsProcessed

      // delay card update (exec 1x)
      this.summaryIntervalId = setTimeout(() => {
        this.getTrailSummaryInfo()
      }, DASHBOARD_POLLING_INTERVAL)

      registerInverval(this.summaryIntervalId)
    } else {
      this.getTrailSummaryInfo()
    }
  },
  mounted () {
    let vm = this
    this.$on('updateDashboardView', function (msg) {
      vm.getTrailSummaryInfo()
    })
  },
  methods: {
    filterByAssignee (user) {
      let queryParams = this.visibleUsers.concat(this.dropdownUsers)
      queryParams = _.chain(queryParams)
        .filter('checked')
        .map(user => {
          return user.email
        })
        .uniq()
        .value()

      this.$router.replace({
        query: {
          assignee: queryParams
        }
      })
    },
    getTrailSummaryInfo () {
      Promise.all([
        this.$store.dispatch(TRAIL_SUMMARY_REQ, 'active'),
        this.$store.dispatch(SYSTEM_TRAIL_SUMMARY_REQ, 'active'),
        this.$store.dispatch(SYSTEM_TRAIL_SUMMARY_REQ, 'privileged'),
        this.$store.dispatch(SYSTEM_TRAIL_SUMMARY_REQ, 'mitigated')
      ]).then(summary => {
        this.eventsConsumedCounter.endVal = summary[0].numEventsProcessed
        this.$store.dispatch(UNIQ_COMBO_LATERAL_MOVEMENT, summary[0].lateralMovementInfoSet || [])
        this.$store.dispatch(UNIQ_COMBO_PRIV_LATERAL_MOVEMENT, summary[0].privLateralMovementInfoSet || [])
      })
    },
    goToNestedView (view) {
      this.$set(this, 'activePostureSelection', view)
      this.$router.push({
        name: `dashboard-${view}`,
        query: this.$route.query
      })
    },
    gotoDetails (view) {
      this.$router.push({
        name: `dashboard-${view}`
      })
    }
  },
  computed: {
    ...mapGetters([
      'usersListStatus',
      'usersList',
      'userProfile',
      'trailsinfoReqStatus',
      'trailsinfoRecords',
      'privilegedTrailRecords',
      'trailSummaryStatus',
      'trailSummary',
      'agentListReqStatus',
      'agentList',
      'activeTrailSummary',
      'activeTrailSummaryStatus',
      'privilegedTrailSummary',
      'privilegedTrailSummaryStatus',
      'mitigatedTrailSummary',
      'mitigatedTrailSummaryStatus',
      'dashboardProgressionDateRangeUserSetting',
      'insightsEnabled'
    ]),
    summaryInfoLineChartOptions () {
      return {
        tooltips: { enabled: false },
        elements: {
          point: { pointStyle: 'line' },
          line: {
            fill: true,
            backgroundColor: 'rgb(242, 248, 255)',
            borderColor: 'rgb(0, 112, 249)'
          }
        }
      }
    },
    activePostureSelection: {
      // getter
      get: function () {
        switch (this.$route.name) {
          case 'dashboard-agents':
            return 'agents'
          case 'dashboard-privileged':
            return 'privileged'
          default:
            return 'trails'
        }
      },
      // setter
      set: function (newValue) {
        this.lastactivePostureSelectionName = newValue
      }
    }
  },
  beforeDestroy () {
    // kill interval calls
    destroyInverval(this.summaryIntervalId)
  },
  components: {
    LineChartJs,
    UserButton,
    PageHeaders,
    ICountUp,
    DateRangeDropdown
  },
  watch: {
    trailSummaryStatus: function (newStatus, oldStatus) {
      if (newStatus !== oldStatus && newStatus === 'saved') {
        this.cardViewStatusOnce = true
      }
    },
    dashboardProgressionDateRangeUserSetting: {
      handler: function (newDateRange, oldDateRange) {
        if (newDateRange !== oldDateRange) {
          this.getTrailSummaryInfo()
        }
      }
    }
  }
}
</script>

<style>
.c-tooltip {
  max-width: 200px;
}
</style>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/colors.css';
@import 'assets/styles/riskscore_colors.css';

.layout-container .container .view {
  padding: 0px;
  overflow: hidden;
}
.page-headers {
  min-height: 45px;
  margin: 20px 10px 0px !important;
  padding: 0px 15px;
}

.material-icons {
  font-size: 20px;
  color: var(--aluminum-400);
  line-height: 27px;
  vertical-align: text-top;
}

.privilege-content {
  padding-left: 10px;
}

.icon-privilege-activities {
  height: 24px;
  width: 24px;
  margin: auto;
  background: var(--denim-700);
  mask: url('/static/images/privilege_symbol.svg');
  mask-size: cover;
}

.el-row {
  &:first-of-type {
    margin: 0px 0px 32px 0px !important;
  }

  &:nth-child(n + 2) {
    background: white;
    padding: 0px 25px;
  }
}

.el-card {
  height: 100%;
  border-top: none;
  border-right: none;
  border-bottom: 1px solid var(--aluminum-400);
  border-left: 1px solid var(--aluminum-400);
  border-radius: 0px;

  >>> .el-card__body {
    padding: 16px !important;
  }
}

.avatar-wrapper {
  align-items: stretch;
}

.avatar-circle {
  color: white;
  letter-spacing: -1px;
  font-size: 13px;
  height: 32px;
  width: 32px;
  padding: 0px;
  margin: -3px;
  position: relative;

  &.active {
    border: 2px solid white;
  }
  &.active::after {
    content: '';
    border: 2px solid #197de6;
    height: 32px;
    width: 32px;
    border-radius: 50%;
    position: absolute;
    left: -4px;
    top: -4px;
  }
}

.el-card.active-card {
  height: calc(100% - 3px);
  border-top: 4px solid var(--denim-600);
  border-bottom: none;
}

.card-header {
  > div.with-border:first-of-type {
    border-right: 1px solid var(--border-color);
  }
  > div {
    padding: 0px 10px;
  }
  span {
    display: block;
  }
  .system-summary_events {
    span {
      display: inline-block;
      line-height: 16px;

      &:last-of-type {
        position: relative;
        top: 10px;
      }
    }
  }
}

.card-content {
  margin-top: 5%;

  > div:first-of-type {
    padding-bottom: 10px;
  }

  > div:nth-child(n + 2) {
    padding-bottom: 5px;
  }

  > div:last-of-type {
  }
}

.system-glance {
  .card-content {
    margin-top: 15%;

    > div:first-of-type {
      padding-top: 10px;
      border-top: 1px solid var(--border-color);
    }
  }
}

.system-summary {
  background-color: var(--background-color);
  border-right: 1px solid var(--aluminum-400);

  .summary-chart {
    width: 85%;
    max-width: 85%;
  }

  .col-3 {
    z-index: 99;
    background: white;
  }
}

.summary-pp {
  .greeting {
    font-weight: bold;
    margin: 0px;
  }

  .summary-info {
    font-size: 0.8em;
    margin: 0.5em;
  }
}

.offline-color {
  border: 1px solid var(--offline-color);
}

.online-color {
  border: 1px solid var(--online-color);
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/ParentSecurityPostureDashboard.vue